import MyAccount from "./myAccount"

export default MyAccount
